import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Animated from '../AnimatedLetters/Animated';
import './AboutMe.scss'

const AboutMe = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])
    return (
        <Container className='about-s'>
            <Row>
                <Col md={8}>

                    <div className="text-zone">
                        <h1>
                            <Animated
                                letterclass={letterClass}
                                strArray={['A', 'b', 'o', 'u', 't', ' ', 'M', 'e']}
                                idx={15}
                            />
                        </h1>
                        <div className='text-white mt-3 mb-5'>
                            <p>Experienced Full Stack Web Developer with a strong focus on modern web technologies including React.js, Django, and REST APIs. Skilled in database management using PostgreSQL and server management with Nginx. Passionate about building scalable, user-friendly applications and managing projects efficiently.</p>

                            <figure className="text-start">
                                <blockquote className="blockquote">
                                    <p>"Can I say something? Um, I'm the type of person that if you ask me a question and I don't know the answer, I'm gonna tell you that I don't know. But I bet you what, I know how to find the answer and <span className='text-warning'>I will find the answer</span>."</p>
                                </blockquote>
                                <figcaption className="blockquote-footer mt-3">
                                    Chris Gardner from <cite title="Source Title">"The Pursuit of Happyness"</cite>
                                </figcaption>
                            </figure>
                        </div>
                    </div>

                </Col>
                <Col md={4}>

                    <div className="d-flex justify-content-center align-items-center">

                        <img className='about-s-i' src="https://i.ibb.co/Mhj7phj/my-prfl-1.jpg" alt="" />

                    </div>

                </Col>
            </Row>
        </Container >

    );
};

export default AboutMe;